import { Card } from 'domain/common/components';

export const ResentCard = () => (
  <Card>
    <p className="mt-6 justify-center px-10 text-center text-xl">
      <div>Email resent</div>
    </p>
  </Card>
);
